import $ from "jquery";
import axios from "axios";
import authHeader from "../auth-header";
import ErrorService from "../error.service";
import AdminService from "../admin.service";
import UserService from "../user.service";
import TableService from "../table.service";
import NeedsService from "../needs.service";
import ChartService from "../chart.service";

const BASE_URL = AdminService.getBaseUrl();
const API_URL = BASE_URL + "/api/v1/chart";

class ValueGroupMap {
    async getValueRoadMapInitiative(surveyCode,needNumber, needType, valueRoadMapId, callback, panelApp) {
        const params = new URLSearchParams();
        params.append("surveyCode", surveyCode);
        params.append("needNumber", needNumber);
        params.append("needType", needType);
        params.append("valueRoadMapId", valueRoadMapId);
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_URL + "/get-value-road-map-initiative", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("Winners.getValueRoadMapInitiative", error, "survey-designer", panelApp);
          });
    }    
    async saveValueRoadMapInitiative(surveyCode, valueRoadMapInitiatives, valueRoadMapId, callback, panelApp) {
        const params = new URLSearchParams();
        params.append("surveyCode", surveyCode);
        params.append("valueRoadMapInitiatives", JSON.stringify(valueRoadMapInitiatives));
        params.append("valueRoadMapId", valueRoadMapId);
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_URL + "/save-value-road-map-initiative", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("Winners.saveValueRoadMapSetup", error, "survey-designer", panelApp);
          });
    }    
    async saveValueRoadMapSetup(surveyCode, focusAreaEfforts, otherAreaEfforts, callback, panelApp) {
        const params = new URLSearchParams();
        params.append("surveyCode", surveyCode);
        params.append("focusAreaEfforts", JSON.stringify(focusAreaEfforts));
        params.append("otherAreaEfforts", JSON.stringify(otherAreaEfforts));
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_URL + "/save-value-road-map-setup", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("Winners.saveValueRoadMapSetup", error, "survey-designer", panelApp);
          });
    }    
    async getDataDrivenPicks(valueRoadMapId, surveyCode, competitors, benchmarks, period, focusAreaEfforts,otherAreaEfforts,clientChartId,callback, panelApp) {
      const params = new URLSearchParams();
      params.append("valueRoadMapId", valueRoadMapId);
      params.append("surveyCode", surveyCode);
      params.append("clientChartId", clientChartId);
      params.append("focusAreaEfforts", JSON.stringify(focusAreaEfforts));
      params.append("otherAreaEfforts", JSON.stringify(otherAreaEfforts));
      params.append("userId", UserService.getUserId());
      params.append("period", period);
      for (var i = 0; i < competitors.length; i++) {
        params.append("competitor_company_id", competitors[i].companyId);
      }      
      for (var index = 0; index < benchmarks.length; index++) {
        params.append("benchmark_company_id", benchmarks[index].companyId);
      }      
      await axios
        .post(API_URL + "/get-data-driven-picks", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("ValueGroupMap.getDataDrivenPicks", error, "survey-designer", panelApp);
        });
    }      

    async getValueRoadMapSetupBySurveyCode(surveyCode, clientChartId, period, surveyGroupId, useEqualWeight, callback, panelApp) {
        const params = new URLSearchParams();
        params.append("surveyCode", surveyCode);
        params.append("clientChartId", clientChartId);
        params.append("period", period);
        params.append("surveyGroupId", surveyGroupId);
        params.append("useEqualWeight", useEqualWeight);
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_URL + "/get-value-road-map-setup-map-by-survey-code", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("ValueGroupMap.getValueRoadMapSetupBySurveyCode", error, "survey-designer", panelApp);
          });
      }    
      removeNodes(originalList){
          let namesToRemove = ["moatInitiatives", "moatDescription","initiativeSuggestions",
            "valueRoadMapFocusAreaId","valueRoadMapId",
            "valueRoadMapTypeId","valueRoadMapTypeName","active","clientChartId","moatName"
          ];
          const result = [];

          originalList.forEach(item => {
              const newItem = {};
              for (let key in item) {
                  if (!namesToRemove.includes(key)) {
                      newItem[key] = item[key];
                  }
              }
              result.push(newItem);
          });
          return result;      
      }
      getRoadMapInitiativesTableColumnData() {
        return [
          {
            data: "null",
            className: "text-center radio-button",
            name: "moatInitiativeId",
            width: "1rem",
            bVisible: true,
            render: function (data, type, row, meta) {
              return `<input type="radio" name="initiativeRadio" value="${row.moatInitiativeId}" class="select-radio suggestions-popup-radio">`;
            }
          },
          { data: "initiative", name: "initiative", width: "18.5rem", class: "text-left pr-2"},
          {
            data: "attributes.successLevel",
            name: "attributes.successLevel",
            width: "2.8rem",
            className: "text-center",
            render: function (data, type, row) {
              try {
                const attrs = JSON.parse(row.attributes || "{}");
                return attrs.successLevel || "";
              } catch (e) {
                return "";
              }
            }
          },
          {
            data: "attributes.salesIncrease",
            name: "attributes.salesIncrease",
            width: "3rem",
            className: "text-center",
            render: function (data, type, row) {
              try {
                const attrs = JSON.parse(row.attributes || "{}");
                return attrs.salesIncrease || "";
              } catch (e) {
                return "";
              }
            }
          },
          {
            data: "attributes.costReduction",
            name: "attributes.costReduction",
            width: "3rem",
            className: "text-center",
            render: function (data, type, row) {
              try {
                const attrs = JSON.parse(row.attributes || "{}");
                return attrs.costReduction || "";
              } catch (e) {
                return "";
              }
            }
          }
        ];
      }
}
export default new ValueGroupMap();
